import request from 'api/request';
import { changeToastState } from '../common_toast';

export const INDEX_NEW_NOTIFICATION = 'INDEX_NEW_NOTIFICATION';
export const INDEX_NEW_POST_DATA = 'INDEX_NEW_POST_DATA';
export const INDEX_AGREEMENT_SHOW = 'INDEX_AGREEMENT_SHOW';

export const indexNewNotification = {
    type: INDEX_NEW_NOTIFICATION,
    data: '1'
};

export const indexAgreementShow = {
    type: INDEX_AGREEMENT_SHOW,
    data: '1'
};

export const indexNewPostData = (data) => (
    {
        type: INDEX_NEW_POST_DATA,
        data,
    }
);
